<template>
  <div id="app">
    <router-view v-if="user || isLogin" :user="user" />
    <StagingBar />
  </div>
</template>

<script>
import User from './models/user'
import baseController from './controllers/base'
import router from './router'
import StagingBar from './components/common/StagingBar'

const UNAUTHORIZED = 401

export default {
  extends: baseController,
  components: {
    StagingBar
  },
  data() {
    return { user: null }
  },
  computed: {
    isLogin() {
      return ['login', 'password'].includes(this.$route.path.split('/')[1])
    }
  },
  created() {
    if (!this.isLogin) {
      this.patchAuth()
      this.getUserData()
    }
  },
  methods: {
    patchAuth() {
      $(document).ajaxComplete((e, xhr) => {
        if (xhr.status === UNAUTHORIZED) {
          this.logout()
        }
      })
      $(document).ajaxSend((e, xhr) => {
        const authKey = User.authKey
        if (authKey) {
          xhr.setRequestHeader('Authorization', `Token ${authKey}`)
        }
      })
      const pin = this.parseQueryString() && this.parseQueryString().pin
      if (pin) {
        User.login({ pin }).done(() =>
          document.location.replace(document.location.pathname)
        )
      }
    },
    async getUserData() {
      try {
        const user = await User.me()
        this.user = user
      } catch (err) {
        console.error(err.responseJSON ? err.responseJSON.detail : err.responseText) // eslint-disable-line no-console
      }
    },
    logout(e) {
      if (e) {
        e.preventDefault()
      }
      User.removeAuthenticationCookie()
      router.push({ path: '/login' })
    }
  }
}
</script>
